import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, shareReplay, tap } from "rxjs/operators";
import { NEXCAR_CREATE_EXPEDIENTE_SYSTEM_PROCESS_NAME } from "../utilities/nexcar-expediente-documents.constants";
import { HttpClientService } from "./http-client.service";

@Injectable()
export class ProcessesService {
  private _flag_cache = new Map<string, Observable<boolean>>();

  constructor(private http: HttpClientService) {}

  public getProcesses(options?: { page?: number; per_page?: number }): Observable<any> {
    const params: { [key: string]: string } = {};
    if (options?.page) params.page = options.page.toString();
    if (options?.per_page) params.per_page = options.per_page.toString();
    return this.http
      .get("/api/processes", Object.keys(params).length > 0 ? { params } : {})
      .pipe(tap(() => console.debug("ProcessesService.getProcesses: Ok.")));
  }

  public updateProcessStatus(id: number, active: boolean): Observable<any> {
    return this.http.put(`/api/processes/${id}`, { active }).pipe(
      tap((process) => {
        const name =
          (process as { process_name?: string; name?: string } | null)?.process_name ??
          (process as { process_name?: string; name?: string } | null)?.name;
        if (name) this.refreshFlag(name);
        console.debug("ProcessesService.updateProcessStatus: Ok.");
      })
    );
  }

  public isNexcarCreateExpedienteProcessActive(): Observable<boolean> {
    return this.isProcessActiveByName(NEXCAR_CREATE_EXPEDIENTE_SYSTEM_PROCESS_NAME);
  }

  public isProcessActiveByName(processName: string): Observable<boolean> {
    return this.getProcesses({ per_page: 500 }).pipe(
      map((data) => {
        const raw = (data as { items?: unknown[] } | null)?.items ?? data;
        const items: unknown[] = Array.isArray(raw) ? raw : [];
        const found = items.find((row) => {
          const r = row as { process_name?: string; name?: string };
          const n = r?.process_name ?? r?.name;
          return n === processName;
        }) as { status?: string; active?: boolean } | undefined;
        if (!found) {
          return false;
        }
        return found.status === "active" || found.active === true;
      })
    );
  }

  public isFlagActive$(processName: string): Observable<boolean> {
    if (!this._flag_cache.has(processName)) {
      this._flag_cache.set(
        processName,
        this.isProcessActiveByName(processName).pipe(
          catchError(() => of(false)),
          shareReplay({ bufferSize: 1, refCount: false })
        )
      );
    }
    return this._flag_cache.get(processName) as Observable<boolean>;
  }

  public refreshFlag(processName: string): void {
    this._flag_cache.delete(processName);
  }
}
